import { Fragment, ReactNode } from 'react'
import classnames from 'classnames'

import { Link } from '~/components'

export default function MediaPageWrapperNavItem({
  children,
  href,
  isActive,
}: {
  children: ReactNode
  href: string
  isActive: boolean
}): React.ReactElement {
  const cx = classnames(
    'px-1.5',
    'py-1',
    'relative',
    'rounded',
    'text-xs',
    'lg:text-md',
    'font-medium',
    isActive ? 'text-purple' : 'hover:bg-purple-light',
  )

  return (
    <Link className={cx} to={href}>
      <span>{children}</span>

      {isActive && (
        <Fragment>
          <span className="absolute top-full left-0 w-full h-0.5 bg-purple" />
        </Fragment>
      )}
    </Link>
  )
}
